import React from 'react';
import { Alert, Icon } from 'antd';

export default class PermissionSplash extends React.Component {
    render() {
        return (
            <div>
                <Alert showIcon type="info"
                    message={
                        <h1>
                            Attention
                                </h1>
                    }
                    description={
                        <h3>
                            You do not have permission to access this page due to security roles.  Please see IT if you need access.&nbsp;&nbsp;<Icon type="rocket" style={{ fontSize: '25px' }} spin />
                        </h3>
                    }
                />
            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./portal-components/PermissionSplash/index.jsx